// extracted by mini-css-extract-plugin
module.exports = {"caption":"styles_caption__39sCU","bold":"styles_bold__3CYbb","fs-4xl":"styles_fs-4xl__3db0U","fs-xl":"styles_fs-xl__2eARu","fs-normal":"styles_fs-normal__2Iv44"};